import { useNavigate } from 'react-router-dom';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick/lib/slider';
import '../styles/Header.scss';

const Carousel = ({ data }) => {
  const navigate = useNavigate();

  const settings = {
    className: 'slider variable-width',
    speed: 500,
    infinite: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 7,
        },
      },
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 930,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 415,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const overFlowDitection = (e) => {
    const dropdown = e.target.closest('.header__item').children[1];
    const dimentions = dropdown.getBoundingClientRect();

    dropdown.classList.remove('overflow__left');
    dropdown.classList.remove('overflow__right');

    if (dimentions.right + 5 > window.innerWidth) {
      dropdown.classList.add('overflow__right');
    } else if (dimentions.x < 0) {
      dropdown.classList.add('overflow__left');
    } else {
      dropdown.classList.remove('overflow__left');
      dropdown.classList.remove('overflow__right');
    }
  };

  return (
    <>
      <Slider {...settings}>
        {data.map((item) => (
          <div
            className="header__item w-32 text-center px-3 cursor-pointer"
            key={item.id}
            onMouseEnter={overFlowDitection}
          >
            <span className="w-5 pointer-events-none whitespace-pre">
              {item.title}
            </span>

            <div
              className={`header__onhover flex flex-row w-fit bg-red-700 rounded-md shadow-md z-50`}
              // onMouseLeave={(e) =>
              //   e.target.parentElement.classList.remove('title__onhover')
              // }
            >
              <img src={item.icon} alt="" />
              <div className="w-fit shrink-0 header__onhover_links grid grid-cols-2 gap-3 md">
                {item.children.map((child) => (
                  <span
                    className="w-full p-2 rounded-md hover:text-red-300"
                    key={child.id}
                    onClick={() => navigate(`/products/cat/${child.id}`)}
                  >
                    {child.title}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </>
  );
};

export default Carousel;
